<template>
  <Layout class="g-wrapper g-vertical-block">
    <Content class="g-main-wrapper g-vertical-block">
      <Row :gutter="12">
        <Col span="24">
          <Tabs :value="currentRoute" @on-click="changeRouter">
            <TabPane name="adcountwarnrules" label="管控规则列表"></TabPane>
            <TabPane name="adcountwarnadd" :label="`${addName}管控规则`"></TabPane>
          </Tabs>
        </Col>
      </Row>
      <div class="c-content">
        <router-view />
      </div>
    </Content>
  </Layout>
</template>
<script>
export default {
  name: 'monitorule',
  computed: {
    addName() {
      return this.editStat ? '修改' : '新增'
    }
  },
  methods: {
    changeRouter(name) {
      this.$router.push({ name })
    },
    getCurrent() {
      if (this.$route.name === 'adcountwarn') this.changeRouter('adcountwarnrules')
      this.editStat = this.$route.name === 'adcountwarnedit'
      this.currentRoute = this.$route.name
    }
  },
  watch: {
    $route: {
      handler() {
        this.getCurrent()
      },
      deep: true
    }
  },
  data() {
    return {
      editStat: null,
      currentRoute: ''
    }
  },
  created() {
    this.getCurrent()
  }
}
</script>
